import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";

const Submenu = ({ items, subMenus }) => {
  const [Submenu, setSubMenu] = useState(subMenus[0]);

  const handleSubMenuSideBar = (index) => {
    console.log("Selected Submenu:", subMenus[index]); // Debugging step

    setSubMenu(subMenus[index]); 
  };

  return (
    <div className="dropdown-menu w-100 border-0 p-0 rounded-0" style={{ display: "block" }}>
      <Row className="border-top border-dark">
        {/* Left side: List of items */}
        <Col md={3} className="pt-3 m-0 pb-3 p-0" id="subMenuBg">
          <ul id="subMenuText">
            {items.map((item, index) => (
              <li
                key={index}
                className="w-100 fs-6 text-none list-unstyled mt-2 ps-3 pe-3 p-2"
                onMouseEnter={() => handleSubMenuSideBar(index)} 
              >
                <Link className="text-decoration-none" to={item.link}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </Col>

        {/* Right side: Display the submenu content based on hover */}
        <Col md={9} className="bgeYantra">
          {Submenu && (
            <Row className="p-3 gap-1">
              <Col md={2}>
                <img src={Submenu.imgSrc} width={150} loading="lazy" className="rounded" alt={Submenu.ParentMenuLabel} />
              </Col>
              <Col md={6}>
                <h2 className="text-black">{Submenu.ParentMenuLabel}</h2>
                <p className="fs-14">{Submenu.ParentMenuDescription}</p>
                <p className="SolutionLink p-2  m-0 rounded">
                  <Link to={Submenu.ParentLink} className="text-black text-decoration-none">Learn More</Link>
                </p>
                
              </Col>
              <Row>
                <Col md={8}>
                <div className="w-100 border-bottom border-dark">
                <p className="text-decoration-none fs-20 w-100 py-2 m-0">{Submenu.solutions[0].Heading}</p>
                </div>
                <ul className="pb-5 p-0">
                  {Submenu.solutions.map((solution, index) => (
                    <li key={index} className="list-unstyled py-1">
                      <Link to={solution.SolutionLink} className="fs-18 text-decoration-none subMenuLabel" >{solution.solutionsLabel}</Link>
                    </li>
                  ))}
                </ul>
                </Col>
              </Row>
              
            </Row>
            
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Submenu;
